import React from 'react';
import PropTypes from 'prop-types';
import RegionGroup from './region-group';
import DistrictGroup from './district-group';
import { jsx as ___EmotionJSX } from "@emotion/core";
var Locality = props => ___EmotionJSX("div", null, props.regions && props.regions.length > 0 && ___EmotionJSX(RegionGroup, props), props.sections && props.sections.length > 0 && ___EmotionJSX(DistrictGroup, props));
Locality.propTypes = {
  regions: PropTypes.arrayOf(PropTypes.shape(RegionGroup.propTypes.regions)),
  sections: PropTypes.arrayOf(PropTypes.shape(DistrictGroup.propTypes))
};
Locality.defaultProps = {
  regions: [],
  sections: []
};
export default Locality;